//libs
import {
    AlertTemplateProps,
} from 'react-alert';

//types
import { IAlertOptionsExt } from '../types/IAlertOptionsExt'

export default function AlertTemplate({ options, message, style }: AlertTemplateProps) {
    const { actions = [], title = '' } = options as IAlertOptionsExt;
    return (
        <div className="new-iek-popup" style={style}>
            <div className="popup-title">{title}</div>
            <div className="popup-message">{message}</div>
            <div className="popup-buttons">
                {actions.map(({ name, onClick, className = '' }) => (
                    <button key={name} className={'ui-button ' + className} onClick={onClick}>
                        {name}
                    </button>
                ))}
            </div>
        </div>
    );
};
